import axios from 'axios';
export const handleUpgradeTier = async (isOpen) => {
  if (window.theme.complete_payment_product_id) {
    const productToAdd = [{
      id: window.theme.complete_payment_product_id,
      properties: null,
      quantity: 1
    }];
    await axios({
      method: 'POST',
      url: '/cart/add.js',
      data: {
        items: productToAdd
      },
      responseType: 'JSON'
    })
      .then((response) => {
        axios({
          method: 'GET',
          url: `/cart.js`,
          responseType: 'JSON',
        })
          .then(res => {
            window.sideCart.updateCart(res.data);
            isOpen && window.sideCart.handleCartToggle();
          })
          .catch(err => window.console.error('Error updating cart in handleAddToCartEvent: ', err));
      })
      .catch(err => err);
  } else {
    console.error("Please check the admin settings. Note: choose the Variant ID, not product ID")
  }
}

export const getLoyaltyOptions = () => {
  let loyaltyTiers = null
  try {
    const loyaltyTiersJsonElement = window.document.querySelector('script[data-loyalty-tiers-config-json]');
    const jsonString = loyaltyTiersJsonElement.innerHTML;
    const loyaltyTiersData = JSON.parse(jsonString);
    loyaltyTiers = loyaltyTiersData.loyaltyTiers;
  } catch (error) {
    console.error('Error parsing JSON:', error);
  }
  return loyaltyTiers
}